import React from 'react';
import { BasicContainer } from '../../UI/ContentContainer';

import map from '../../../assets/img/map.png';
import map2 from '../../../assets/img/map2.png';
import TextContent from '../../UI/TextContent';
import DirectionContents from './DirectionContents';

const DirectionsPage = () => {
    return (
        <BasicContainer>
            <TextContent title="오시는길" styleTitle={{marginBottom: '50px'}}>
                <DirectionContents
                    companyLocation="천안 본사"
                    map={map}
                    companyAddress="충남 천안시 서북구 두정상가1길 5, 새아스빌 202호"
                    businessHour="08:00 ~ 17:00"
                    tel="041-555-7422"
                    fax="041-968-8422"
                    email="dreamsafety1201@naver.com"
                />

                <DirectionContents
                    companyLocation="서울 사무소"
                    map={map2}
                    companyAddress="서울특별시 서초구 서초대로64길 31"
                    businessHour="08:00 ~ 17:00"
                />
            </TextContent>
        </BasicContainer>
    )
}

export default DirectionsPage;